import { render } from "./Jerarquias.vue?vue&type=template&id=5c6ac7da"
import script from "./Jerarquias.vue?vue&type=script&lang=js"
export * from "./Jerarquias.vue?vue&type=script&lang=js"

import "./Jerarquias.vue?vue&type=style&index=0&id=5c6ac7da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__